export enum ETypePost {
  Create = 1,
  ReplyComment,
}

export enum ETypeFiles {
  Image = 'image',
  Video = 'video',
}
